import { createContext, useContext, ReactNode } from 'react';
import { useAssets } from '../hooks/assets/useAssets';

export type AssetsContextType = ReturnType<typeof useAssets>;

export const AssetsContext = createContext<AssetsContextType | null>(null);

export const AssetsProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const assetsState = useAssets();

  return (
    <AssetsContext.Provider value={assetsState}>
      {children}
    </AssetsContext.Provider>
  );
};

export const useAssetsContext = (): AssetsContextType => {
  const context = useContext(AssetsContext);
  if (!context) {
    throw new Error('useAssetsContext must be used within an AssetsProvider');
  }
  return context;
};
